(function () {
  var badgeNormalizeTimer;

  function initCarousel(scope) {
    if (scope.dataset.lusciousCarouselReady === 'true') return;

    var track = scope.querySelector('[data-luscious-track]');
    var prev = scope.querySelector('[data-luscious-prev]');
    var next = scope.querySelector('[data-luscious-next]');
    if (!track || !prev || !next) return;

    scope.dataset.lusciousCarouselReady = 'true';

    function step(direction) {
      var firstItem = track.querySelector('.luscious-clean-carousel__item');
      var itemWidth = firstItem ? firstItem.getBoundingClientRect().width : track.clientWidth / 2;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
      track.scrollBy({ left: direction * (itemWidth + gap), behavior: 'smooth' });
    }

    prev.addEventListener('click', function () {
      step(-1);
    });

    next.addEventListener('click', function () {
      step(1);
    });
  }

  function initTabs(section) {
    if (section.dataset.lusciousTabsReady === 'true') return;

    var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-luscious-tab-button]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-luscious-tab-panel]'));
    var viewLinks = Array.prototype.slice.call(section.querySelectorAll('[data-luscious-tab-view]'));
    if (!buttons.length || !panels.length) return;

    section.dataset.lusciousTabsReady = 'true';

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var targetId = button.dataset.target;

        buttons.forEach(function (item) {
          var active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var active = panel.id === targetId;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });

        viewLinks.forEach(function (link) {
          link.classList.toggle('is-hidden', link.dataset.target !== targetId);
        });

        var activePanel = section.querySelector('#' + CSS.escape(targetId));
        if (activePanel) {
          activePanel.querySelectorAll('[data-luscious-carousel]').forEach(initCarousel);
        }
      });
    });
  }

  function initCleanCommerce(root) {
    root.querySelectorAll('[data-luscious-carousel]').forEach(initCarousel);
    root.querySelectorAll('.luscious-clean-tabs').forEach(initTabs);
    normalizeSaleBadges(root);
  }

  function scheduleSaleBadgeNormalize(root) {
    window.clearTimeout(badgeNormalizeTimer);
    badgeNormalizeTimer = window.setTimeout(function () {
      normalizeSaleBadges(root || document);
    }, 80);
  }

  function normalizeSaleBadges(root) {
    root.querySelectorAll('.sale-badge, .product-badges__badge, .luscious-card__badge').forEach(function (badge) {
      var text = badge.textContent.replace(/\s+/g, ' ').trim();
      var match = text.match(/(\d+)\s*%(?:\s*OFF)?/i);
      if (match && text !== match[1] + '% OFF') {
        badge.textContent = match[1] + '% OFF';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCleanCommerce(document);
    [250, 1000, 2500, 5000].forEach(function (delay) {
      window.setTimeout(function () {
        normalizeSaleBadges(document);
      }, delay);
    });

    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        var shouldNormalize = mutations.some(function (mutation) {
          if (mutation.type === 'characterData') return true;
          return Array.prototype.some.call(mutation.addedNodes, function (node) {
            return node.nodeType === 1;
          });
        });

        if (shouldNormalize) {
          scheduleSaleBadgeNormalize(document);
        }
      }).observe(document.documentElement, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    initCleanCommerce(event.target);
    scheduleSaleBadgeNormalize(event.target);
  });
})();
